export default __webpack_public_path__ + "static/media/icon-scissors.3b1a5d7e.svg";